<template>
  <Transition name="zoom-fade" class="z-[2147483646]">
    <div
      v-if="props.display"
      class="fixed inset-0 bg-black/40 flex items-center justify-center pointer-events-auto cursor-pointer"
      @mousedown.self="emit('close')"
    >
      <slot name="header"></slot>

      <div
        class="cursor-auto flex items-center justify-center modal-content"
        :class="{ 'w-full h-4/5': props.fullscreen }"
      >
        <slot></slot>
      </div>

      <slot name="footer"></slot>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const emit = defineEmits(['close']);

const props = defineProps<{ display: boolean; fullscreen?: boolean }>();

onMounted(() => {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      emit('close');
    }
  });
});

onUnmounted(() => {
  document.removeEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      emit('close');
    }
  });
});
</script>

<style scoped>
.zoom-fade-enter-active,
.zoom-fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.modal-content {
  transition: all 0.3s ease-in-out;
}

.zoom-fade-enter-from,
.zoom-fade-leave-to {
  opacity: 0;
}

.zoom-fade-enter-from > .modal-content,
.zoom-fade-leave-to > .modal-content {
  transform: scale(0.9);
}
</style>
